import { getStore } from 'store';
import { SET_GLOBAL } from 'store/key';
import { produce } from 'utility/general';

const initialState = {
    isShowDrawer: true,
    dashboardDate: 'today',
    isShowInHospitalBase: false,
    searchRefreshKey: 'initialize',
    compareChangeKey: 'initialize',
    postApprovalReportData: {},
};

export const setGlobal = (data) => ({
    type: SET_GLOBAL,
    payload: data,
});

export const setGlobalLoading = (isShow) => {
    const store = getStore();
    store.dispatch(
        setGlobal({
            isGlobalLoadingShow: isShow,
        }),
    );
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_GLOBAL:
            const newState = produce(state, (draft) => {
                Object.entries(action.payload).forEach(([key, value]) => {
                    draft[key] = action.payload[key];
                });
            });
            return newState;
        default:
            return state;
    }
};
export default reducer;
